import { useLoader } from "./LoaderContext";

const PageLoader = () => {
  const { loading } = useLoader();

  if (!loading) return null;

  return (
    <div className="page-loader">
      <div className="spinner" />
    </div>
  );
};

export default PageLoader;